import * as React from 'react';
import { Route, Switch } from 'react-router';
import Home from './components/Home';
import FleetThemeTestPage from './components/_dev/FleetThemeTestPage';
import AlternativeCalculationPage from './components/_dev/AlternativeCalculationPage';
import Login from './components/auth/LogIn';
import TwoFactor from './components/auth/TwoFactor';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import SessionManager from './components/auth/SessionManager';
import AuthPersistence from './components/auth/AuthPersistence';
import GuestGuard from './components/guard/GuestGuard';
import AppUser from './components/admin/users/AppUsers';
import UserDetails from './components/admin/users/UserDetails';
import EditRole from './components/admin/users/EditRole';
import AppReferentials from './components/admin/listOfValues/AppReferentials';
import OtherListsOfValues from './components/admin/otherLists/OtherListsOfValues';

import moment from 'moment';
import 'moment/locale/cs';
import 'moment/locale/nl';
import 'moment/locale/ro';
import 'moment/locale/pl';
import 'moment/locale/sk';

import { ApplicationContext, AppContext } from './context/Contexts';
import { History } from 'history';
import { connect } from 'react-redux';
import { ApplicationState, AppActionCreators, AppState } from './store';
import MuiTheme from './theme';
import { ThemeProvider, Snackbar } from '@material-ui/core';
import { LeftSidebar } from './layout-blueprints/index';
import { Constants, RoleClaimsEnum } from './helpers/Constants';
import './custom.css';
import UserProfile from './components/userProfile/userProfile';
import { ITranslatorService } from './services/Interfaces/ITranslatorService';
import OrganizationAdmin from './components/admin/organizations/OrganizationAdmin';
import HOOrganizations from './components/admin/organizations/HOOrganizations';
import EditOrganization from './components/admin/organizations/EditOrganization';
import GtXML from './components/admin/xmlDocument/GtXML';
import NewCase from './components/newCase/NewCase';
import WorkflowAdmin from './components/admin/workflows/WorkflowAdmin';
import Cases from './components/cases/Cases';
import CaseDetails from './components/cases/CaseDetails';
import Dashboards from './components/dashboards/Dashboards';
import Orders from './components/orders/Orders';
import Vehicles from './components/vehicles/Vehicles';
import DetailsOfCarForm from './components/vehicles/DetailsOfCarForm';
import CertificateOfControlForm from './components/vehicles/CertificateOfControl';
import UserOrganizationInterfaces from './components/settings/UserOrganizationInterfaces';
import VehiclesHistory from './components/vehicles/VehiclesHistory';
import CarClassRentalPrice from './components/admin/car-class-rent-price/CarClassRentalPrice';
import Billing from './components/billing/Billing';
import DgpciBilling from './components/billing/DgpciBilling';
import OrderPartsHistory from './components/order-parts-history/OrderPartsHistory';
import VersionList from './components/nomenclature/version/VersionList';
import BodyTypeList from './components/nomenclature/bodyType/BodyTypeList';
import BodyConditionTypeList from './components/nomenclature/bodyConditionType/BodyConditionTypeList';
import WheelConditionTypeList from './components/nomenclature/wheelConditionType/WheelConditionTypeList';
import InvoiceRangeList from './components/nomenclature/invoiceRange/InvoiceRangeList';
import ProvenanceList from './components/nomenclature/provenance/ProvenanceList';
import ExchangeRateList from './components/nomenclature/exchangeRateList/ExchangeRateList';
import AlcorErrorLogList from './components/nomenclature/alcorErrorLog/AlcorErrorLogList';
import FinancialParameterInfoList from './components/nomenclature/financialParameterInfo/FinancialParameterInfoList';
import SellerDataList from './components/nomenclature/sellerData/SellerDataList';
import MavoVehicles from './components/mavo-vehicles/MavoVehicles';
import MavoVehicleDetailsForm from './components/mavo-vehicles/MavoVehicleDetailsForm';
import MavoVehicleStockDetailsForm from './components/mavo-vehicles/MavoVehicleStockDetailsForm';
import MavoVehiclesAuctions from './components/mavo-vehicles/MavoVehiclesAuctions';
import MavoVehiclesUserAuctions from './components/mavo-vehicles/MavoVehiclesUserAuctions';
import MavoVehiclesAdminAuctions from './components/mavo-vehicles/MavoVehiclesAdminAuctions';
import MavoVehiclesOrders from './components/mavo-vehicles/MavoVehiclesOrders';
import PoEditor from './components/admin/poeditor/PoEditor';
import MaintenanceCupiOptionalPartComponent from './components/admin/maintenance-cupi-optional-part/MaintenanceCupiOptionalPartComponent';
import VoInvoiceHistory from './components/mavo-vehicles/VoInvoiceHistory';
import MavoAppUsers from './components/admin/users/MavoAppUsers';
import MavoUserDetails from './components/admin/users/MavoUserDetails';
import AlcorParameterInfoList from './components/nomenclature/alcorParameterInfo/AlcorParameterInfoList';
import UserManual from './components/user-manual/UserManual';
import MavoHOOrganizations from './components/admin/organizations/MavoHOOrganizations';
import MavoOrganizationAdmin from './components/admin/organizations/MavoOrganizationAdmin';
import ModelCarClass from './components/admin/model-car-class/ModelCarClass';
import AgendaPage from './components/agenda/AgendaPage';
import AppointmentPage from './components/appointment/AppointmentPage';
import AddNewAppointmentPage from './components/appointment/AddNewAppointmentPage';
import MaintenanceProducerComponent from './components/admin/maintenance-producer/MaintenanceProducerComponent';
import EvaluationPage from './components/evaluation/EvaluationPage';
import EvaluationCarFile from './components/evaluation/EvaluationCarFile';
import EvaluationHistory from './components/evaluation/EvaluationHistory';
import GTWSBilling from './components/billing/GTWSBilling';
import CountryBufferComponent from './components/admin/country-buffer/CountryBufferComponent';
import { ProviderContext, withSnackbar } from 'notistack';
import NonStockPartBilling from './components/billing/NonStockPartBilling';
import OrderDetailsPage from './components/orders/OrderDetailsPage';
import OrderPageNew from './components/orders/OrderPageNew';
import ColorList from './components/nomenclature/color/ColorList';
import MavoVehiclesUserOrders from './components/mavo-vehicles/MavoVehiclesUserOrders';
import { EventSource, EventSourceInit } from 'eventsource';
import { Appointment, Case, CaseList } from './interfaces/Case';
import { OrganizationService } from './services/OrganizationService';
import { IOrganizationService } from './services/Interfaces/IOrganizationService';
import { isNullOrUndefined } from 'util';
import { isEqual } from 'lodash';
import { Organization } from './interfaces/Organization';
import { useAppDispatch } from './store/configureStore';
import { IRefreshService } from './services/Interfaces/IRefreshService';
import { UserNotificationsUpdate } from './interfaces/UserNotificationsUpdate';
import CountrySupportComponent from './components/admin/country-support/CountrySupportComponent';
import GeneralNotification from './components/general-notification/GeneralNotification';
import NewBillingReport from './components/billing/NewBillingReport';
import PowerBiReportComponent from './components/admin/power-bi-report/PowerBiReportComponent';
import PowerBiReport from './components/powerBi/PowerBiReport';
import PartOptionCupiCodeComponent from './components/admin/part-option-cupi-code/PartOptionCupiCodeComponent';
import TopProducerComponent from './components/admin/top-producer/TopProducerComponent';
import GTRepo from './components/admin/vq-repo/GTRepo';
import ExchangeRateCoefficient from './components/exchange-rate-coefficient/ExchangeRateCoefficient';
import OrdersExport from './components/orders-export/OrdersExport';
import RepairServiceInvoicesExport from './components/repair-service-invoices-export/RepairServiceInvoicesExport';
import ClaimBoxAdvertiserComponent from './components/admin/claimbox-advertiser/ClaimBoxAdvertiserComponent';
import OilViscosityMakeCorrespondenceComponent from './components/admin/oil-viscosity-make-correspondence/OilViscosityMakeCorrespondenceComponent';
import UserWorkflowSuppliers from './components/workflow-suppliers/UserWorkflowSuppliers';
import UserSupplierProducers from './components/supplier-producer/UserSupplierProducers';
import WorkflowSupplierProducerDiscountComponent from './components/supplier-producer-discount/WorkflowSupplierProducerDiscountComponent';
import GTSupplierMappingComponent from './components/admin/gt-supplier-mapping/GTSupplierMappingComponent';
import VehicleVQRequeryComponent from './components/admin/vehicle-vq-requery/VehicleVQRequeryComponent';
import RepoVQComponent from './components/admin/repo-vq/RepoVQComponent';
import NonStockOrdersExport from './components/non-stock-orders-export/NonStockOrdersExport';
import MvoVehiclesExport from './components/mvo-vehicles-export/MvoVehiclesExport';
import DealerStartStockComponent from './components/admin/dealer-start-stock/DealerStartStockComponent';
import StockPartComponent from './components/admin/stock-part/StockPartComponent';
import MaintenanceCategoryCountryComponent from './components/admin/maintenance-category-country/MaintenanceCategoryCountryComponent';
import ConfigurableWorkflowComponent from './components/admin/configurable-workflow/ConfigurableWorkflowComponent';
import ValuationBilling from './components/billing/ValuationBilling';
import LegalDocuments from './components/admin/legal-documents/LegalDocuments';
import AcceptConnectLegalDocumentsGuard from './components/guard/AcceptConnectLegalDocumentsGuard';
import TermsAndConditionsPage from './components/legal/TermsAndConditionsPage';
import PrivacyPolicyPage from './components/legal/PrivacyPolicyPage';
import PdfReaderPage from './components/legal/PdfReaderPage';
import Loader from './components/Loader';

type AppProps = AppState & typeof AppActionCreators & History & ProviderContext;

class App extends React.PureComponent<AppProps> {
  private translatorService!: ITranslatorService;
  static contextType = ApplicationContext;

  public async componentDidMount() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.translatorService.LoadLanguage();

    const path = this.props.location!.pathname;

    let accessToken = localStorage.getItem('access_token');

    if (!accessToken) {
      const safariToken = sessionStorage.getItem('safari_auth_token');
      const safariRefresh = sessionStorage.getItem('safari_auth_refreshToken');
      if (safariToken) {
        accessToken = safariToken;
        localStorage.setItem('access_token', safariToken);
        if (safariRefresh) {
          localStorage.setItem('refresh_token', safariRefresh);
        }
      }
    }

    if (!accessToken) {
      const publicPaths = ['/auth/', '/terms-and-conditions', '/privacy-policy', '/pdf-reader'];
      const isPublicPath = publicPaths.some((p) => path.startsWith(p));
      if (!isPublicPath) {
        window.location.href = '/auth/login';
      }
      this.updateMomentLanguage();
      return;
    }

    const refreshToken = localStorage.getItem('refresh_token');
    this.props.SetToken(accessToken);
    if (refreshToken) {
      this.props.SetRefreshToken(refreshToken);
    }

    await this.props.SetUser(this.props.enqueueSnackbar);
    await this.props.LoadCurrencyRates(this.props.appUser?.organization);
    this.updateMomentLanguage();
  }

  public componentDidUpdate(prevProps: any) {
    if (prevProps.language !== this.props.language) {
      this.updateMomentLanguage();
    }
  }

  public updateMomentLanguage = () => {
    const language = this.props.language;
    const languageList: any = { ro: 'ro', cz: 'cs', pl: 'pl', nl: 'nl', en: 'en', sk: 'sk' };

    moment.locale(language ? languageList[language] : 'ro');
    moment.updateLocale(language ? languageList[language] : 'ro', { week: { dow: 1, doy: 4 } });
  };

  private handleCloseMessage = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    this.props.Message(false);
  };

  public hasRight = (right: string): boolean => {
    const role = this.props.user?.profile?.role;
    if (!role) return false;
    if (Array.isArray(role)) return role.includes(right);
    return role === right;
  };

  public renderUserRoutes = () => {
    if (!this.props.appUser) {
      return;
    }

    return (
      <React.Fragment>
        <Route exact path="/fleet-theme" component={FleetThemeTestPage} />
        <Route exact path="/alternative-calculation" component={AlternativeCalculationPage} />
        {this.hasRight(RoleClaimsEnum.Home) ? <Route exact path="/" component={Home} /> : null}
        {this.hasRight(RoleClaimsEnum.NewCase) ? (
          <Route exact path="/newCase" component={NewCase} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Agenda) ? (
          <Route exact path="/newCase/:id" component={NewCase} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Case) ? (
          <Route exact path="/cases" component={Cases} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Case) ? (
          <Route exact path="/cases/:id" component={CaseDetails} />
        ) : null}
        {/* { this.hasRight(RoleClaimsEnum.Case) ? <Route exact path='/cases/:id/comments' component={CaseDetails} /> : null } */}
        {this.hasRight(RoleClaimsEnum.Case) ? (
          <Route exact path="/cases/:id/:formId" component={CaseDetails} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Case) ? (
          <Route exact path="/cases/:id/:formId/:calcId" component={CaseDetails} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Case) ? (
          <Route exact path="/cases/:id/:formId/:calcId/callback" component={CaseDetails} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Dashboard) ? (
          <Route exact path="/dashboards" component={Dashboards} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Evaluation) ? (
          <Route exact path="/valuation" component={EvaluationPage} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Evaluation) ? (
          <Route exact path="/valuation/history" component={EvaluationHistory} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Case) ? (
          <Route exact path="/valuation/file/:id" component={EvaluationCarFile} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Order) ? (
          <Route exact path="/orders" component={Orders} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Order) ? (
          <Route exact path="/order-parts-history" component={OrderPartsHistory} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Vehicle) ? (
          <Route exact path="/vehicles" component={Vehicles} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Agenda) ? (
          <Route exact path="/agenda" component={AgendaPage} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Agenda) ? (
          <Route exact path="/appointment/:id" component={AppointmentPage} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Agenda) ? (
          <Route exact path="/appointment" component={AddNewAppointmentPage} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Vehicle) ? (
          <Route exact path="/vehicles-history" component={VehiclesHistory} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Vehicle) ? (
          <Route exact path="/vehicle/:id/:type" component={DetailsOfCarForm} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Vehicle) ? (
          <Route exact path="/vehicle/:id" component={DetailsOfCarForm} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Vehicle) ? (
          <Route exact path="/certificate" component={CertificateOfControlForm} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Settings) ? (
          <Route exact path="/settings/interfaces" component={UserOrganizationInterfaces} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminUsers) ? (
          <Route path="/admin/users" exact component={AppUser} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/admin/mavo/users" exact component={MavoAppUsers} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminUsers) ? (
          <Route path="/admin/users/:id" component={UserDetails} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/admin/mavo/users/:id" component={MavoUserDetails} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminUsers) ||
        this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/admin/roles" exact component={AppUser} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminUsers) ||
        this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/admin/roles/:id" component={EditRole} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/listOfValues" component={AppReferentials} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/otherListOfValues" component={OtherListsOfValues} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminOrganization) ||
        this.hasRight(RoleClaimsEnum.AdminCountryOrganization) ? (
          <Route path="/admin/hoorganizations" exact component={HOOrganizations} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminOrganization) ||
        this.hasRight(RoleClaimsEnum.AdminCountryOrganization) ||
        this.hasRight(RoleClaimsEnum.AdminService) ? (
          <Route
            path="/admin/hoorganizations/:id"
            exact
            render={(props) => <OrganizationAdmin key={props.match.params.id} {...props} />}
          />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminOrganization) ||
        this.hasRight(RoleClaimsEnum.AdminCountryOrganization) ||
        this.hasRight(RoleClaimsEnum.AdminService) ? (
          <Route path="/admin/organizations/:id" component={EditOrganization} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminOrganization) ? (
          <Route
            path="/admin/hoorganizations/:id/workflow/:workflowId"
            exact
            component={WorkflowAdmin}
          />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminUsers) ||
        this.hasRight(RoleClaimsEnum.MavoAdministrator) ||
        this.hasRight(RoleClaimsEnum.AdminCountryOrganization) ? (
          <Route path="/admin/poeditor" exact component={PoEditor} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminOrganization) ? (
          <Route path="/admin/xml" exact component={GtXML} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/car-class-rent-price" component={CarClassRentalPrice} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/model-car-class" component={ModelCarClass} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.ManagerExport) || this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route exact path="/billing" component={Billing} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route exact path="/billing-dgpci" component={DgpciBilling} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route exact path="/billing-ws" component={GTWSBilling} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route exact path="/billing-non-stock" component={NonStockPartBilling} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route exact path="/billing-valuation" component={ValuationBilling} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route
            path="/admin/maintenance-cupi-part"
            component={MaintenanceCupiOptionalPartComponent}
          />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/maintenance-producer" component={MaintenanceProducerComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/country-support" component={CountrySupportComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/country-buffer" component={CountryBufferComponent} />
        ) : null}
        <Route path="/profile" component={UserProfile} />

        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/color" component={ColorList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/version" component={VersionList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/bodyType" component={BodyTypeList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/bodyConditionType" component={BodyConditionTypeList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/wheelConditionType" component={WheelConditionTypeList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/invoice-range" component={InvoiceRangeList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/provenance" component={ProvenanceList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/currency" component={ExchangeRateList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ||
        this.hasRight(RoleClaimsEnum.MavoContab) ? (
          <Route path="/nomenclature/alcor-error-log" component={AlcorErrorLogList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ||
        this.hasRight(RoleClaimsEnum.MavoContab) ? (
          <Route path="/nomenclature/alcor-parameters" component={AlcorParameterInfoList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/financial-parameter" component={FinancialParameterInfoList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/nomenclature/seller-data" component={SellerDataList} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route exact path="/mavo-vehicles" component={MavoVehicles} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoVehicle) ? (
          <Route exact path="/mavoVehicle/:id" component={MavoVehicleDetailsForm} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoVehicle) ? (
          <Route exact path="/mavoVehicleStock/:id" component={MavoVehicleStockDetailsForm} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAgent) ||
        this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route exact path="/auctions" component={MavoVehiclesAuctions} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAgent) ? (
          <Route exact path="/user/auctions" component={MavoVehiclesUserAuctions} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route exact path="/admin/auctions" component={MavoVehiclesAdminAuctions} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route exact path="/mavo/orders" component={MavoVehiclesOrders} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAgent) ? (
          <Route exact path="/mavo/user/orders" component={MavoVehiclesUserOrders} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAgent) ||
        this.hasRight(RoleClaimsEnum.MavoContab) ||
        this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route exact path="/invoice-history" component={VoInvoiceHistory} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/admin/mavo/hoorganizations" exact component={MavoHOOrganizations} />
        ) : null}

        {this.hasRight(RoleClaimsEnum.MavoAdministrator) ? (
          <Route path="/admin/mavo/hoorganizations/:id" exact component={MavoOrganizationAdmin} />
        ) : null}
        <Route exact path="/user-manual" component={UserManual} />
        {this.hasRight(RoleClaimsEnum.Order) ? (
          <Route exact path="/orders/:id" component={OrderPageNew} />
        ) : // <Route exact path="/orders/:id" component={OrderDetailsPage} />
        null}
        <Route exact path="/general-notification" component={GeneralNotification} />
        {this.hasRight(RoleClaimsEnum.Admin) || this.hasRight(RoleClaimsEnum.ManagerFacturare) ? (
          <Route exact path="/case-billing" component={NewBillingReport} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/power-bi-reports" component={PowerBiReportComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.PowerBi) ? (
          <Route path="/power-bi/:reportCode" component={PowerBiReport} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/cupi-part-code" component={PartOptionCupiCodeComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/top-producer" component={TopProducerComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminOrganization) ? (
          <Route path="/admin/vq-repo" exact component={GTRepo} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.RaportComenzi) ||
        this.hasRight(RoleClaimsEnum.ManagerComenziAP) ? (
          <Route exact path="/orders-export" component={OrdersExport} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route
            exact
            path="/repair-service-invoices-export"
            component={RepairServiceInvoicesExport}
          />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Dealer) || this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route path="/exchange-rate-coefficient" exact component={ExchangeRateCoefficient} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/claimbox-advertiser" component={ClaimBoxAdvertiserComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route
            path="/admin/oil-viscosity-correspondence"
            component={OilViscosityMakeCorrespondenceComponent}
          />
        ) : null}
        {this.hasRight(RoleClaimsEnum.UserAdminFurnizori) ? (
          <Route exact path="/settings/suppliers" component={UserWorkflowSuppliers} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.ConfiguratorExtradiscount) ? (
          <Route exact path="/settings/producers" component={UserSupplierProducers} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.ConfiguratorExtradiscount) ? (
          <Route
            exact
            path="/settings/producers-discounts"
            component={WorkflowSupplierProducerDiscountComponent}
          />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route path="/admin/gt-supplier-mapping" component={GTSupplierMappingComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route path="/admin/vehicle-vq-requery" component={VehicleVQRequeryComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route path="/admin/vq-repo-data" component={RepoVQComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.RaportComenzi) ? (
          <Route exact path="/supplier-response-report" component={NonStockOrdersExport} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.ManagerMvo) ? (
          <Route exact path="/mvo-vehicles-export" component={MvoVehiclesExport} />
        ) : null}

        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/dealer-start-stock" component={DealerStartStockComponent} />
        ) : null}
        {this.hasRight(RoleClaimsEnum.ManagerStockPropriu) ? (
          <Route exact path="/settings/stock-part" component={StockPartComponent} />
        ) : null}

        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route path="/admin/configurable-workflow" component={ConfigurableWorkflowComponent} />
        ) : null}

        {this.hasRight(RoleClaimsEnum.AdminValueList) ? (
          <Route
            path="/admin/maintenance-category-based-country"
            component={MaintenanceCategoryCountryComponent}
          />
        ) : null}

        {this.hasRight(RoleClaimsEnum.Admin) ? (
          <Route path="/admin/legal-documents" exact component={LegalDocuments} />
        ) : null}
      </React.Fragment>
    );
  };

  public render() {
    const path = this.props.location!.pathname;
    const publicPaths = ['/auth/', '/terms-and-conditions', '/privacy-policy', '/pdf-reader'];
    const isPublicPath = publicPaths.some((p) => path.startsWith(p));
    // Show a full-page loader while the profile loads (login / reload after org
    // switch), so the authenticated routes don't flash a blank screen.
    const showGeneralLoader = this.props.isGeneralLoading;

    return (
      <ThemeProvider theme={MuiTheme}>
        <LeftSidebar>
          <AuthPersistence />
          {this.props.user && <SessionManager />}
          {showGeneralLoader ? (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                position: 'fixed',
                inset: 0,
                zIndex: 2000,
                backgroundColor: '#fff'
              }}
            >
              <Loader />
            </div>
          ) : (
            <Switch>
              <Route
                path="/auth/login"
                render={() => (
                  <GuestGuard>
                    <Login />
                  </GuestGuard>
                )}
              />
              <Route
                path="/auth/2FA"
                render={() => (
                  <GuestGuard>
                    <TwoFactor />
                  </GuestGuard>
                )}
              />
              <Route
                path="/auth/forgot-password"
                render={() => (
                  <GuestGuard>
                    <ForgotPassword />
                  </GuestGuard>
                )}
              />
              <Route
                path="/auth/reset-password"
                render={() => (
                  <GuestGuard>
                    <ResetPassword />
                  </GuestGuard>
                )}
              />
              <Route path="/terms-and-conditions" exact component={TermsAndConditionsPage} />
              <Route path="/privacy-policy" exact component={PrivacyPolicyPage} />
              <Route path="/pdf-reader" exact component={PdfReaderPage} />
              {this.renderUserRoutes()}
              {/* <Redirect from="/*" to="/" /> */}
            </Switch>
          )}
          {this.props.appUser && (
            <AcceptConnectLegalDocumentsGuard>{null}</AcceptConnectLegalDocumentsGuard>
          )}
          <Snackbar
            open={this.props.showMessage}
            autoHideDuration={1500}
            onClose={this.handleCloseMessage}
          ></Snackbar>
        </LeftSidebar>
      </ThemeProvider>
    );
  }
}

export default connect(
  (state: ApplicationState) => state.app,
  AppActionCreators
)(withSnackbar(App as any));
